import React from 'react';
export function LoadingBox({ style, children }) {
    return React.createElement("div", { className: 'ltg-loading-box', style: style }, children);
}
